export default __webpack_public_path__ + "static/media/cv_pic_jonas_bienz.51d66d9f.jpg";